// age.js -- pure date-of-birth helpers (spec §6). Single job: validate a calendar date and compute
// whole-year age on the phone's LOCAL date. Never stores or sends a date.
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const isLeap = (y) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;

export function isRealDate(dob) {
  const { y, m, d } = dob || {};
  if (![y, m, d].every(Number.isInteger)) return false;
  if (m < 1 || m > 12 || d < 1) return false;
  const dt = new Date(Date.UTC(y, m - 1, d));
  return dt.getUTCFullYear() === y && dt.getUTCMonth() === m - 1 && dt.getUTCDate() === d;
}
export function todayLocal(now = new Date()) {
  return { y: now.getFullYear(), m: now.getMonth() + 1, d: now.getDate() };
}
export function yearRange(today) {
  return { min: today.y - 120, max: today.y };
}
export function ageOn(dob, today) {
  let bm = dob.m;
  let bd = dob.d;
  if (bm === 2 && bd === 29 && !isLeap(today.y)) { bm = 3; bd = 1; }
  const hadBirthday = today.m > bm || (today.m === bm && today.d >= bd);
  return today.y - dob.y - (hadBirthday ? 0 : 1);
}
export function isAtLeast21(dob, today) {
  return ageOn(dob, today) >= 21;
}
export function formatDob(dob) {
  return `${MONTHS[dob.m - 1]} ${dob.d}, ${dob.y}`;
}
